import { remove } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";

import { invalidateWorkerLockQueries } from "./invalidateWorkerLockQueries";

interface DeleteWorkerLockParams {
  workplaceId: string;
  lockId: string;
}

export function useDeleteWorkerLock() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: DeleteWorkerLockParams) => {
      const { workplaceId, lockId } = params;
      const url = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workplaces/${workplaceId}/worker-visit-locks/${lockId}`;

      await remove({
        url,
        responseSchema: z.unknown(),
      });
    },
    onSuccess: () => {
      invalidateWorkerLockQueries(queryClient);
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.DELETE_WORKER_LOCK_FAILURE,
    },
  });
}
